import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import { IPost } from '../types';
import Button from './Button';

interface IProps {
	posts: Array<IPost>;
}

const NoResults = ({ posts }: IProps) => {
	const { clearFilters } = useFiltersContext();

	if (!posts.length) {
		const handleOnClick = () => {
			if (clearFilters) {
				clearFilters();
			}
		};

		return (
			<div className="pfa-no-results">
				<h2 className="pfa-no-results__title">No Results Found</h2>
				<p className="pfa-no-results__description">
					There are no results for the filters you&apos;ve selected.
				</p>
				<Button
					text="Clear Filters"
					onClick={handleOnClick}
					className="pfa-no-results__clear btn-primary"
				/>
			</div>
		);
	}

	return <></>;
};

NoResults.displayName = 'NoResults';

export default NoResults;
